import type { ReactNode } from "react";
import { AlertTriangle, CheckCircle2, Info, ShieldOff } from "lucide-react";

export type FeedbackTone = "info" | "success" | "warning" | "danger";

/**
 * 唯一正式反馈横幅。只有异常、阻断、失败恢复和一次性风险提醒才使用横幅；
 * 稳定业务口径优先进入 PageHeader / SectionCard meta，不占首屏。
 */
export function FeedbackBanner({ tone, title, children, action }: {
  tone: FeedbackTone;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}) {
  const Icon = tone === "success" ? CheckCircle2 : tone === "danger" ? AlertTriangle : tone === "warning" ? AlertTriangle : Info;
  return <div className={`feedback-banner ${tone}`} role={tone === "danger" ? "alert" : "status"} aria-live="polite">
    <Icon size={17} aria-hidden />
    <div className="feedback-banner-main">
      <strong>{title}</strong>
      {children && <span>{children}</span>}
    </div>
    {action && <div className="feedback-banner-action">{action}</div>}
  </div>;
}

/** 字段级与步骤级内联反馈；错误与字段相邻并进入 aria-live。 */
export function InlineFeedback({ tone, children }: { tone: FeedbackTone; children: ReactNode }) {
  const Icon = tone === "success" ? CheckCircle2 : tone === "danger" ? AlertTriangle : tone === "warning" ? AlertTriangle : Info;
  return <div className={`inline-feedback-item ${tone}`} role="status" aria-live="polite"><Icon size={14} aria-hidden /><span>{children}</span></div>;
}

/** 权限或安全阻断提示（blocked 态专用）。 */
export function BlockedNotice({ title, description }: { title: string; description: string }) {
  return <div className="feedback-banner blocked" role="alert">
    <ShieldOff size={17} aria-hidden />
    <div className="feedback-banner-main">
      <strong>{title}</strong>
      <span>{description}</span>
    </div>
  </div>;
}
